import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "body__header" }
const _hoisted_3 = { class: "body__header__title" }
const _hoisted_4 = { class: "title--text" }
const _hoisted_5 = { class: "body__header__desc" }
const _hoisted_6 = { class: "type-list" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "type-list__button__text--title" }
const _hoisted_9 = { class: "type-list__button__value" }
const _hoisted_10 = { class: "type-list__button__text--value" }
const _hoisted_11 = { class: "type-list__button__text--unit" }
const _hoisted_12 = { class: "type-list__button__icon" }
const _hoisted_13 = { class: "main" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "unresolved"
}
const _hoisted_16 = { class: "title--text" }
const _hoisted_17 = { class: "unresolved-button__container" }
const _hoisted_18 = { class: "unresolved-button" }
const _hoisted_19 = { class: "unresolved-button__title" }
const _hoisted_20 = { class: "unresolved-button__value" }
const _hoisted_21 = { class: "next-icon" }
const _hoisted_22 = { class: "main__header" }
const _hoisted_23 = { class: "main__header__title" }
const _hoisted_24 = { class: "main__header__desc" }
const _hoisted_25 = { class: "main__setting" }
const _hoisted_26 = { class: "setting__header__label" }
const _hoisted_27 = { class: "setting__header__label__title" }
const _hoisted_28 = { class: "setting__header__label__item" }
const _hoisted_29 = { class: "text-bold" }
const _hoisted_30 = { class: "setting__header__label__item" }
const _hoisted_31 = { class: "text-bold" }
const _hoisted_32 = {
  key: 0,
  class: "setting__header__label__item"
}
const _hoisted_33 = { class: "text-bold" }
const _hoisted_34 = { class: "setting__inputs" }
const _hoisted_35 = { class: "input__wrap" }
const _hoisted_36 = { class: "input__wrap" }
const _hoisted_37 = {
  key: 0,
  class: "input__wrap"
}
const _hoisted_38 = { class: "setting__control" }
const _hoisted_39 = { class: "setting__control__link" }
const _hoisted_40 = { class: "main__control" }
const _hoisted_41 = { class: "main__control__filter" }
const _hoisted_42 = { class: "main__control__alert-filter" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "main__table base-table-wrapper" }
const _hoisted_45 = { class: "main__table__header__inner" }

import Mdi from '@/corePagesModule/components/Mdi.vue';
import { i18n } from '@/i18n';
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import InventoryDashboardChildLayout from '../InventoryDashboardChildLayout.vue';
import { DetailAlertData } from '../useInventoryDashboardStore/types';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { initPagingOptions, IPagingOptions } from '@/coreDomainsModule/paging';
import { LoadingStatus } from '@/corePagesModule/components/ezTable/types';
import { InventoryDashboardViewModel } from '../inventoryDashboardViewModel';
import { DETAIL_HEADER_OPTION, PAGE_CONFIG, PageType } from '@/inventoryDashboardModule/constants';
import EzTable from '@/corePagesModule/components/ezTable/EzTable.vue';
import EzHeader from '@/corePagesModule/components/ezTable/EzHeader.vue';
import EzTableRow from '@/corePagesModule/components/ezTable/EzTableRow.vue';
import EzCell from '@/corePagesModule/components/ezTable/EzCell.vue';
import Pagination from '@/corePagesModule/components/Pagination.vue';
import FilterModalButton from '@/corePagesModule/filterModal/FilterModalButton.vue';
import { useInventoryDashboardStore } from '../useInventoryDashboardStore';
import ArrowIcon from '@/corePagesModule/BaseTableContent/components/ArrowIcon.vue';
import RowCheckBox from '@/components/atom/RowCheckBox.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';
import ErrorMessage from '@/corePagesModule/components/ErrorMessage.vue';
import AlertInputSharp from '@/inventoryDashboardModule/components/alertInput/AlertInputSharp.vue';
import AlertInputConsecutive from '@/inventoryDashboardModule/components/alertInput/AlertInputConsecutive.vue';
import { diContainer } from '@/coreContainer/container';
import {
  DashboardAlertDirection,
  DashboardAlertSetting,
  dashboardAlertSettingValidation,
  DashboardAlertSettingValueType,
  DashboardAlertType,
  DashboardAlertTypes,
} from '@/inventoryDashboardModule/domains/entities/DashboardAlert';
import { DashboardAlertSettingFactory } from '@/inventoryDashboardModule/domains/factories/DashboardAlertSettingFactory';
import { showInfoModal } from '@/corePagesModule/components/InfoModal/InfoModalManager';
import DashboardAlertBadge from '@/inventoryDashboardModule/components/DashboardAlertBadge.vue';
import { waitLoading } from '@/corePagesModule/components/InfoModal/waitLoading';
import { useTableHeader } from '@/corePagesModule/composables/useTableHeader';
import { HeaderList } from '@/coreDomainsModule/table';
import TableHeaderModifyButton from '@/corePagesModule/components/TableHeaderModifyButton.vue';
import { toast } from '@/corePagesModule/components/Toast/ToastManager';
import AlertInputCurrent from '@/inventoryDashboardModule/components/alertInput/AlertInputCurrent.vue';
import DashboardAlertReasonList from '@/inventoryDashboardModule/components/DashboardAlertReasonList.vue';
import { useColumnResizer } from '@/corePagesModule/composables/useColumnResizer';
import { useColumnWidth } from '@/corePagesModule/composables/useColumnWidth';

type ViewType = (typeof ViewType)[number];


export default /*@__PURE__*/_defineComponent({
  __name: 'OverviewAlertDetailPage',
  setup(__props) {

_useCssVars(_ctx => ({
  "2773d0bd": (`repeat(${displayViewTypeList.value.length}, minmax(0, 1fr))`),
  "7f67e929": (isShortageForecastCurrentActive.value ? 3 : 2)
}))

const t = i18n.t;
const route = useRoute();

const store = useInventoryDashboardStore();
const { getDetailAggregateBusinessWithAlertData } = store;
const vm = new InventoryDashboardViewModel();

/**
 * detailAlertData初期化
 */
const initDetailAlertData = (): DetailAlertData => ({
  overview: {
    excess: 0,
    shortage: 0,
    unresolved: {
      unmatched: 0,
      noOrderNumber: 0,
      deadline: 0,
    },
  },
  businesses: [],
});

const viewType = ref<ViewType>('none');
const loadingStatus = ref<LoadingStatus>({ type: 'loading' });
const sortType = ref<'ASC' | 'DESC'>('DESC');
const sortTarget = ref<string | undefined>(undefined);
const pagingOptions = ref<IPagingOptions>(initPagingOptions(30));
const filterItems = ref<FilterContentItem[]>([]);
const checkedBusinessId = ref<string[]>([]);

const detailAlertData = ref<DetailAlertData>(initDetailAlertData());
const alertSettings = ref<DashboardAlertSetting>(DashboardAlertSettingFactory.create());
const isDisplaySetting = ref<boolean>(false);
const errorMessage = ref<string>('');

const tableRef = ref<HTMLElement | null>(null);
const tableWidthInfo = ref<Record<string, number | undefined>>({});

const ViewType = ['excess', 'shortage', 'unresolved', 'none'] as const;
/**
 * アラート詳細画面で扱う表示カテゴリ
 */
const displayViewTypeList = computed((): ViewType[] =>
  pageType.value === PageType.Critical ? ['excess', 'shortage'] : ['excess', 'shortage', 'unresolved']
);

const loadingStatusWithView = computed((): LoadingStatus => {
  if (loadingStatus.value.type === 'success') {
    return { type: detailAlertData.value.businesses.length === 0 ? 'zero-match' : 'success' };
  }
  return loadingStatus.value;
});

const pageType = computed((): Extract<PageType, 'critical' | 'warning'> => {
  const severity = route.query.severity;
  if (!severity) throw new Error();
  switch (severity) {
    case 'warning':
      return PageType.Warning;
    case 'critical':
      return PageType.Critical;
  }
  throw new Error();
});

const pageConfig = computed(() => {
  if (!pageType.value) return { title: 'エラー', desc: '' };
  return PAGE_CONFIG[pageType.value] ?? { title: 'エラー', desc: '' };
});

const headerOption = computed(() => DETAIL_HEADER_OPTION[pageType.value]);
const fullHeaderKeys = computed(() => headerOption.value.map((h) => h.key));
const { headerList, updateDisplayHeader } = useTableHeader(fullHeaderKeys, 'inventoryDashboardAlert', []);
useColumnWidth({ tableType: 'inventoryDashboardAlert', widthInfo: tableWidthInfo });
const { onMousedownResizer } = useColumnResizer({
  tableType: 'inventoryDashboardAlert',
  widthInfo: tableWidthInfo,
  tableEl: tableRef,
  option: { maxWidth: 1000 },
});

const modifiableHeaders = computed(
  (): HeaderList =>
    headerOption.value
      .filter((h) => !['checkbox', 'detail', 'headerModify'].includes(h.key))
      .map((h) => ({
        key: h.key,
        text: vm.convertHeaderKeyToDisplayValue(h.key),
        isShown: headerList.value.includes(h.key),
      }))
);

const gridTemplateColumns = computed(() =>
  headerOption.value
    .filter((header) => headerList.value.includes(header.key))
    .map((h) => {
      const saved = tableWidthInfo.value[h.key];
      return saved ? `${saved}px` : `minmax(${h.width}px, ${h.width}fr)`;
    })
);

const settingSectionDesc = computed(() =>
  viewType.value === 'excess'
    ? {
        reason1: 'excess_forecast_consecutive_low' as DashboardAlertType,
        reason2: 'excess_forecast_sharp_decrease' as DashboardAlertType,
      }
    : {
        reason1: 'shortage_forecast_consecutive_high' as DashboardAlertType,
        reason2: 'shortage_forecast_sharp_increase' as DashboardAlertType,
      }
);

const sharpConditionKey = computed(() =>
  viewType.value === 'excess'
    ? 'dashboard:アラート概要:前回受領内示比n%以下かつ差分m以上'
    : 'dashboard:アラート概要:前回受領内示比n%以上かつ差分m以上'
);

const consecutiveConditionKey = computed(() =>
  viewType.value === 'excess' ? 'dashboard:アラート概要:nヶ月連続でm%以下' : 'dashboard:アラート概要:nヶ月連続でm%以上'
);

const alertFilterItems = computed((): DashboardAlertType[] => {
  switch (viewType.value) {
    case 'excess':
      return ['excess_forecast_sharp_decrease', 'excess_forecast_consecutive_low'];
    case 'shortage':
      return pageType.value === 'critical'
        ? [
            'shortage_forecast_sharp_increase',
            'shortage_forecast_consecutive_high',
            'shortage_forecast_current_high',
            'shortage_out_of_stock',
          ]
        : ['shortage_forecast_sharp_increase', 'shortage_forecast_consecutive_high'];
    default:
      return [...DashboardAlertTypes];
  }
});

const isShortageForecastCurrentActive = computed(() => pageType.value === 'critical' && viewType.value === 'shortage');

const alertFilterInfo = ref<DashboardAlertType[]>(alertFilterItems.value);

/**
 * Refリセット
 */
const $reset = () => {
  loadingStatus.value = { type: 'loading' };
  sortType.value = 'DESC';
  sortTarget.value = undefined;
  pagingOptions.value = initPagingOptions(30);
  filterItems.value = [];
  detailAlertData.value = initDetailAlertData();
  alertSettings.value = DashboardAlertSettingFactory.create();
  isDisplaySetting.value = false;
  errorMessage.value = '';
};

/**
 * 初期フェッチ(設定込み)
 */
const initFetch = async () => {
  $reset();
  const res = await waitLoading(
    Promise.all([
      getDetailAggregateBusinessWithAlertData(
        pageType.value === PageType.Critical ? 'critical' : 'warning',
        viewType.value === 'excess' ? 'excess' : 'shortage',
        sortType.value,
        sortTarget.value,
        pagingOptions.value.pageSize,
        pagingOptions.value.offset,
        filterItems.value,
        alertFilterInfo.value,
        undefined
      ),
      (async () => {
        const res = await diContainer.getDashboardAlertSettingUseCase.execute();
        switch (res.status.type) {
          case 'success':
            return res.status.data;
          default:
            return null;
        }
      })(),
    ]),
    undefined,
    ''
  );
  if (!res || !res[0] || !res[1]) {
    showInfoModal({
      icon: 'error',
      modalTitle: t('取得に失敗しました'),
      modalDescription: t('情報の取得に失敗しました。リロードしてください。'),
      backButtonLabel: 'OK',
      isDisabledNextButton: true,
    });
    loadingStatus.value.type = 'error';
    return;
  }
  detailAlertData.value = res[0][0];
  pagingOptions.value = res[0][1];
  alertSettings.value = res[1];
  loadingStatus.value.type = 'success';
};

/**
 * データのみフェッチ
 */
const fetch = async () => {
  loadingStatus.value.type = 'loading';
  const severity = pageType.value === PageType.Critical ? 'critical' : 'warning';
  const res = await getDetailAggregateBusinessWithAlertData(
    severity,
    viewType.value === 'excess' ? 'excess' : 'shortage',
    sortType.value,
    sortTarget.value,
    pagingOptions.value.pageSize,
    pagingOptions.value.offset,
    filterItems.value,
    alertFilterInfo.value,
    alertSettings.value[severity]
  );
  if (!res) {
    showInfoModal({
      icon: 'error',
      modalTitle: t('取得に失敗しました'),
      modalDescription: t('情報の取得に失敗しました。リロードしてください。'),
      backButtonLabel: 'OK',
      isDisabledNextButton: true,
    });
    loadingStatus.value.type = 'error';
    return;
  }
  detailAlertData.value = res[0];
  pagingOptions.value = res[1];
  loadingStatus.value.type = 'success';
};

/**
 * 表示カテゴリの切り替えハンドラ。
 * @param changedType - 切り替え先の表示カテゴリ
 */
const onClickTypeButton = async (changedType: ViewType) => {
  checkedBusinessId.value = [];
  viewType.value = changedType;
  await fetch();
};

/**
 * ページング変更時のハンドラ
 * @param option - pagingOption
 */
const onChangePagingHandler = async (option: IPagingOptions) => {
  pagingOptions.value = { ...option };
  await fetch();
};

/**
 * フィルター適用時のハンドラ
 * @param changedFilterItems - 変更したフィルタ情報
 */
const onApplyFilterHandler = async (changedFilterItems: FilterContentItem[]) => {
  filterItems.value = [...changedFilterItems];
  await fetch();
};

/**
 * ヘッダーキーをソート用のキーに変換する
 * @param headerKey - ヘッダーキー
 */
const convertHeaderKeyToSortKey = (headerKey: string) => {
  if (headerKey === 'reason') return '';
  return headerKey;
};

/**
 * ソートの矢印を押した時のハンドラ
 * @param headerKey - ヘッダーキー
 */
const onClickSortArrowHandler = async (headerKey: string) => {
  const sortKey = convertHeaderKeyToSortKey(headerKey);
  if (sortTarget.value === sortKey) {
    sortType.value = sortType.value === 'ASC' ? 'DESC' : 'ASC';
  } else {
    sortTarget.value = sortKey;
    sortType.value = 'ASC';
  }
  pagingOptions.value = initPagingOptions(pagingOptions.value.pageSize);
  await fetch();
};

/**
 * 設定変更のinputイベント
 * @param e - イベント
 * @param key - イベントが発生したinputのキー
 */
const onInput = (e: Event, key: DashboardAlertSettingValueType) => {
  const value = (e.target as HTMLInputElement).value;
  alertSettings.value[pageType.value][viewType.value][key] = value;
  errorMessage.value = dashboardAlertSettingValidation(pageType.value, viewType.value as DashboardAlertDirection, value, key);
};

/**
 * 設定の表示非表示切り替え
 */
const changeDisplaySetting = () => {
  isDisplaySetting.value = !isDisplaySetting.value;
};

/**
 * アラートのフィルタボタンを押した際の処理
 * @param value - 押下したボタン値
 */
const onClickAlertFilterButton = (value: DashboardAlertType) => {
  if (alertFilterInfo.value.includes(value)) {
    alertFilterInfo.value = alertFilterInfo.value.filter((a) => a !== value);
  } else {
    alertFilterInfo.value.push(value);
  }
  fetch();
};

/**
 * チェックされたかどうか
 * @param businessId - 対象の取引ID
 * @param isChecked - チェック済みかどうか
 */
const onCheckedRow = (businessId: string, isChecked: boolean) => {
  if (isChecked && !checkedBusinessId.value.includes(businessId)) {
    checkedBusinessId.value.push(businessId);
  } else if (!isChecked && checkedBusinessId.value.includes(businessId)) {
    checkedBusinessId.value = checkedBusinessId.value.filter((b) => b !== businessId);
  }
};

/**
 * ヘッダーを切り替える処理
 * @param headerKey - ヘッダーキー
 * @param isHide - 隠すかどうか
 */
const onToggleHeader = async (headerKey: string, isHide: boolean) => {
  await updateDisplayHeader(headerKey, isHide);
};

/**
 * アラート非表示ボタンクリックハンドラ
 */
const onClickAlertDismissButton = async () => {
  const isConfirm = await showInfoModal({
    modalTitle: t('アラートを非表示にしますか？'),
    modalDescription: t('チェックをつけた取引のアラートを次のデータ更新まで非表示にしますか？(過剰、不足どちらも非表示になります)'),
    backButtonLabel: t('キャンセル'),
    nextButtonLabel: t('実行'),
  });
  if (!isConfirm) return;
  const result = await waitLoading(diContainer.updateAlertVisibilityUseCase.execute(checkedBusinessId.value, true));
  switch (result?.status.type) {
    case 'success':
      checkedBusinessId.value = [];
      await fetch();
      toast.success(t('保存しました'));
      return;
    case 'error':
    default:
      toast.error(t('エラーが発生しました。リロードして再度お試しください。'));
      return;
  }
};

onMounted(async () => {
  await initFetch();
});
onUnmounted(() => {
  viewType.value = 'none';
  $reset();
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(InventoryDashboardChildLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (pageConfig.value.icon)
              ? (_openBlock(), _createBlock(Mdi, {
                  key: 0,
                  icon: pageConfig.value.icon.name,
                  variant: (pageConfig.value.icon.variant as any),
                  style: _normalizeStyle(pageConfig.value.icon.style)
                }, null, 8, ["icon", "variant", "style"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)(pageConfig.value.title)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, _toDisplayString(pageConfig.value.desc && _unref(t)(pageConfig.value.desc)), 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayViewTypeList.value, (key) => {
            return (_openBlock(), _createElementBlock("button", {
              key: key,
              class: _normalizeClass(["type-list__button", { 'type-list__button--active': viewType.value === key }]),
              onClick: ($event: any) => (onClickTypeButton(key))
            }, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)(`dashboard:${pageType.value}_${key}`)), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(key === 'unresolved'
                  ? Object.keys(detailAlertData.value.overview[key]).reduce((acc, k) => (acc += detailAlertData.value.overview[key][k]), 0)
                  : detailAlertData.value.overview[key]), 1),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(t)('件')), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(Mdi, {
                  class: "type-list__button__text--title",
                  icon: "arrow_forward"
                })
              ])
            ], 10, _hoisted_7))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_13, [
          (viewType.value === 'none')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(t)('項目をクリックすると詳細情報を表示します')), 1))
            : (viewType.value === 'unresolved')
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('未対応の内訳')), 1),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailAlertData.value.overview.unresolved, (value, type) => {
                      return (_openBlock(), _createBlock(_component_RouterLink, {
                        key: type,
                        to: type === 'unmatched' ? '/unmatched-orders' : '/firm-order',
                        target: "_blank"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(t)(`dashboard:${type}`)), 1),
                              _createElementVNode("div", _hoisted_20, _toDisplayString(value + _unref(t)('件')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(Mdi, {
                                class: "title__text",
                                icon: "chevron_right"
                              })
                            ])
                          ])
                        ], undefined, true),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)(`dashboard:${pageType.value}_${viewType.value}`)), 1),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('以下の条件に該当する在庫アラートを表示しています。')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("button", {
                      class: "setting__header",
                      onClick: changeDisplaySetting
                    }, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(t)('条件設定と実行')), 1),
                        (!isDisplaySetting.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_28, [
                                _createVNode(DashboardAlertBadge, {
                                  severity: pageType.value,
                                  alert: settingSectionDesc.value.reason2
                                }, null, 8, ["severity", "alert"]),
                                _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)(sharpConditionKey.value, {
                          n: alertSettings.value[pageType.value][viewType.value].momChangeRateThreshold,
                          m: alertSettings.value[pageType.value][viewType.value].minQuantityThreshold,
                        })), 1)
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(DashboardAlertBadge, {
                                  severity: pageType.value,
                                  alert: settingSectionDesc.value.reason1
                                }, null, 8, ["severity", "alert"]),
                                _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(t)(consecutiveConditionKey.value, {
                          n: alertSettings.value[pageType.value][viewType.value].consecutiveMonths,
                          m: alertSettings.value[pageType.value][viewType.value].ratioThreshold,
                        })), 1)
                              ]),
                              (isShortageForecastCurrentActive.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                    _createVNode(DashboardAlertBadge, {
                                      severity: pageType.value,
                                      alert: "shortage_forecast_current_high"
                                    }, null, 8, ["severity"]),
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(t)('dashboard:アラート概要:内示に対して当月の出荷済み数量がn%を超える', {
                          n: alertSettings.value[pageType.value][viewType.value].currentMonthForecastAccuracyThreshold,
                        })), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (errorMessage.value !== '')
                            ? (_openBlock(), _createBlock(ErrorMessage, {
                                key: 1,
                                "is-error": "",
                                "error-message": errorMessage.value
                              }, null, 8, ["error-message"]))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(Mdi, {
                          icon: isDisplaySetting.value ? 'expand_less' : 'expand_more'
                        }, null, 8, ["icon"])
                      ])
                    ]),
                    (isDisplaySetting.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createVNode(AlertInputSharp, {
                                severity: pageType.value,
                                direction: viewType.value,
                                "mom-change-rate-threshold": alertSettings.value[pageType.value][viewType.value].momChangeRateThreshold,
                                "min-quantity-threshold": alertSettings.value[pageType.value][viewType.value].minQuantityThreshold,
                                "onUpdate:momChangeRateThreshold": _cache[0] || (_cache[0] = (e) => onInput(e, 'momChangeRateThreshold')),
                                "onUpdate:minQuantityThreshold": _cache[1] || (_cache[1] = (e) => onInput(e, 'minQuantityThreshold'))
                              }, null, 8, ["severity", "direction", "mom-change-rate-threshold", "min-quantity-threshold"])
                            ]),
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(AlertInputConsecutive, {
                                direction: viewType.value,
                                "consecutive-months": alertSettings.value[pageType.value][viewType.value].consecutiveMonths,
                                "ratio-threshold": alertSettings.value[pageType.value][viewType.value].ratioThreshold,
                                "onUpdate:consecutiveMonths": _cache[2] || (_cache[2] = (e) => onInput(e, 'consecutiveMonths')),
                                "onUpdate:ratioThreshold": _cache[3] || (_cache[3] = (e) => onInput(e, 'ratioThreshold'))
                              }, null, 8, ["direction", "consecutive-months", "ratio-threshold"])
                            ]),
                            (isShortageForecastCurrentActive.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                  _createVNode(AlertInputCurrent, {
                                    threshold: alertSettings.value[pageType.value][viewType.value].currentMonthForecastAccuracyThreshold,
                                    "onUpdate:threshold": _cache[4] || (_cache[4] = (e) => onInput(e, 'currentMonthForecastAccuracyThreshold'))
                                  }, null, 8, ["threshold"])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createVNode(TextButton, {
                              disabled: errorMessage.value !== '',
                              size: "btn-sm",
                              class: "setting__control__confirm",
                              onClick: fetch
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('実行')), 1)
                              ], undefined, true),
                              _: 1
                            }, 8, ["disabled"]),
                            _createVNode(TextButton, {
                              "button-style": "btn-secondary",
                              size: "btn-sm",
                              class: "setting__control__confirm",
                              onClick: initFetch
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('リセット')), 1)
                              ], undefined, true),
                              _: 1
                            }),
                            _createVNode(_component_RouterLink, { to: "/settings/logic/dashboard-alert" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_39, _toDisplayString(_unref(t)('詳細設定ページへ')), 1)
                              ], undefined, true),
                              _: 1
                            })
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(FilterModalButton, {
                        "filter-modal-type": "inventoryDashboardDetailAgg",
                        "select-input-index": 10,
                        "filter-items": filterItems.value,
                        onApply: onApplyFilterHandler
                      }, null, 8, ["filter-items"]),
                      _createElementVNode("div", _hoisted_42, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alertFilterItems.value, (alert) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: alert,
                            class: _normalizeClass({ 'main__control__alert-filter__button--off': !alertFilterInfo.value.includes(alert) }),
                            onClick: () => onClickAlertFilterButton(alert)
                          }, [
                            _createVNode(DashboardAlertBadge, {
                              severity: pageType.value,
                              alert: alert,
                              "with-icon-name": alertFilterInfo.value.includes(alert) ? 'visibility' : 'visibility_off'
                            }, null, 8, ["severity", "alert", "with-icon-name"])
                          ], 10, _hoisted_43))
                        }), 128))
                      ]),
                      _createVNode(TextButton, {
                        disabled: !checkedBusinessId.value.length,
                        onClick: onClickAlertDismissButton
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('アラートを非表示にする')), 1)
                        ], undefined, true),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _createVNode(Pagination, {
                      "paging-options": pagingOptions.value ?? _unref(initPagingOptions)(0),
                      "is-loading": loadingStatus.value.type === 'loading',
                      "no-bottom-margin": "",
                      onOnChangePage: _cache[5] || (_cache[5] = ($event: any) => (onChangePagingHandler($event)))
                    }, null, 8, ["paging-options", "is-loading"])
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _createVNode(EzTable, {
                      ref_key: "tableRef",
                      ref: tableRef,
                      "grid-template-columns": gridTemplateColumns.value,
                      "loading-status": loadingStatusWithView.value,
                      "sticky-header": "",
                      "is-vertical-scrollable": "",
                      class: "main__table__container"
                    }, {
                      header: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerList).slice(0, -1), (header, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (header === 'checkbox')
                              ? (_openBlock(), _createBlock(EzHeader, {
                                  key: 0,
                                  class: "main__table__header"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(RowCheckBox)
                                  ], undefined, true),
                                  _: 1
                                }))
                              : (header === 'detail')
                                ? (_openBlock(), _createBlock(EzHeader, {
                                    key: 1,
                                    "content-padding": 0,
                                    "force-center": "",
                                    class: "main__table__header"
                                  }))
                                : (_openBlock(), _createBlock(EzHeader, {
                                    key: 2,
                                    "use-resizer": "",
                                    class: "main__table__header",
                                    onResizer: (e) => _unref(onMousedownResizer)(e, header)
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_45, [
                                        _createTextVNode(_toDisplayString(_unref(vm).convertHeaderKeyToDisplayValue(header)) + " ", 1),
                                        (header !== 'reason')
                                          ? (_openBlock(), _createBlock(ArrowIcon, {
                                              key: 0,
                                              asc: convertHeaderKeyToSortKey(header) === sortTarget.value ? sortType.value === 'ASC' : false,
                                              class: "main__table__header__icon",
                                              onOnClick: () => onClickSortArrowHandler(header)
                                            }, null, 8, ["asc", "onOnClick"]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ], undefined, true),
                                    _: 2
                                  }, 1032, ["onResizer"]))
                          ], 64))
                        }), 128)),
                        _createVNode(EzHeader, {
                          sticky: "right",
                          class: "main__table__header"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TableHeaderModifyButton, {
                              "modifiable-header-list": modifiableHeaders.value,
                              onToggle: onToggleHeader
                            }, null, 8, ["modifiable-header-list"])
                          ], undefined, true),
                          _: 1
                        })
                      ]),
                      body: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailAlertData.value.businesses, (data, index1) => {
                          return (_openBlock(), _createBlock(EzTableRow, {
                            key: index1,
                            "grid-template-columns": gridTemplateColumns.value
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(headerList).slice(0, -1), (header, index2) => {
                                return (_openBlock(), _createElementBlock(_Fragment, {
                                  key: `inner-${index2}`
                                }, [
                                  (header === 'checkbox')
                                    ? (_openBlock(), _createBlock(EzCell, {
                                        key: 0,
                                        "is-highlighted": checkedBusinessId.value.includes(data.businessId),
                                        class: "main__table__cell"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(RowCheckBox, {
                                            onChangeStatus: (isChecked) => onCheckedRow(data.businessId, isChecked)
                                          }, null, 8, ["onChangeStatus"])
                                        ], undefined, true),
                                        _: 2
                                      }, 1032, ["is-highlighted"]))
                                    : (header === 'detail')
                                      ? (_openBlock(), _createBlock(EzCell, {
                                          key: 1,
                                          "content-padding": 0,
                                          "is-highlighted": checkedBusinessId.value.includes(data.businessId),
                                          class: "main__table__cell"
                                        }, {
                                          default: _withCtx(() => [
                                            (data.businessId)
                                              ? (_openBlock(), _createBlock(_component_RouterLink, {
                                                  key: 0,
                                                  to: { name: 'recommend-order', params: { id: data.businessId } },
                                                  target: "_blank"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(TextButton, {
                                                      class: "table-detail-button",
                                                      "button-style": "btn-secondary",
                                                      "on-click": () => {}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_unref(t)('詳細')), 1)
                                                      ], undefined, true),
                                                      _: 1
                                                    })
                                                  ], undefined, true),
                                                  _: 2
                                                }, 1032, ["to"]))
                                              : _createCommentVNode("", true)
                                          ], undefined, true),
                                          _: 2
                                        }, 1032, ["is-highlighted"]))
                                      : (
                        [
                          'aggregateBusinessResponsibleUsers',
                          'baseBusinessResponsibleUsers',
                          'forecastForReceiptResponsibleUsers',
                        ].includes(header)
                      )
                                        ? (_openBlock(), _createBlock(EzCell, {
                                            key: 2,
                                            "is-highlighted": checkedBusinessId.value.includes(data.businessId),
                                            class: "main__table__cell"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_unref(vm).convertUserAccountToDisplayValue(data[header])), 1)
                                            ], undefined, true),
                                            _: 2
                                          }, 1032, ["is-highlighted"]))
                                        : (header === 'reason')
                                          ? (_openBlock(), _createBlock(EzCell, {
                                              key: 3,
                                              "no-use-tooltip": "",
                                              "is-highlighted": checkedBusinessId.value.includes(data.businessId),
                                              class: "main__table__cell"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(DashboardAlertReasonList, {
                                                  severity: pageType.value,
                                                  alerts: data.alerts
                                                }, null, 8, ["severity", "alerts"])
                                              ], undefined, true),
                                              _: 2
                                            }, 1032, ["is-highlighted"]))
                                          : (_unref(vm).numberHeaderKeys.includes(header))
                                            ? (_openBlock(), _createBlock(EzCell, {
                                                key: 4,
                                                "is-number": "",
                                                "is-highlighted": checkedBusinessId.value.includes(data.businessId),
                                                class: "main__table__cell"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_unref(vm).convertNumberStringToDisplayValue(header, data[header])), 1)
                                                ], undefined, true),
                                                _: 2
                                              }, 1032, ["is-highlighted"]))
                                            : (_openBlock(), _createBlock(EzCell, {
                                                key: 5,
                                                "is-highlighted": checkedBusinessId.value.includes(data.businessId),
                                                class: "main__table__cell"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(data[header] ?? '--'), 1)
                                                ], undefined, true),
                                                _: 2
                                              }, 1032, ["is-highlighted"]))
                                ], 64))
                              }), 128)),
                              _createVNode(EzCell)
                            ], undefined, true),
                            _: 2
                          }, 1032, ["grid-template-columns"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["grid-template-columns", "loading-status"])
                  ])
                ], 64))
        ])
      ])
    ], undefined, true),
    _: 1
  }))
}
}

})